import { useSession } from "@/stores/session";
import { useTheme } from "@/stores/theme";
import { useNavigate } from "@tanstack/react-router";
import { authApi } from "@/api/auth";
import { ChevronsUpDown, LogOut, Moon, Sun, UserRound } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";

export function UserMenu() {
  const user = useSession((s) => s.user);
  const clear = useSession((s) => s.clear);
  const theme = useTheme((s) => s.theme);
  const toggleTheme = useTheme((s) => s.toggle);
  const nav = useNavigate();
  if (!user) return null;

  const initial = user.email.charAt(0).toUpperCase();
  const role = user.role ? user.role[0].toUpperCase() + user.role.slice(1) : "Member";

  async function handleLogout() {
    try { await authApi.logout(); } catch { /* ignore */ }
    clear();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    void nav({ to: "/login" as any });
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton size="lg" className="data-[state=open]:bg-sidebar-accent">
          <span className="flex aspect-square size-8 shrink-0 items-center justify-center rounded-lg bg-brand/15 text-xs font-semibold text-brand ring-1 ring-inset ring-brand/25">
            {initial}
          </span>
          <div className="grid flex-1 text-left leading-tight">
            <span className="truncate text-[13px] font-medium">{user.email}</span>
            <span className="truncate text-[11px] text-muted-foreground">{role}</span>
          </div>
          <ChevronsUpDown className="ml-auto size-4 opacity-60" />
        </SidebarMenuButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="right" align="end" sideOffset={8} className="w-56">
        <DropdownMenuLabel className="flex flex-col gap-0.5">
          <span className="text-xs font-normal text-muted-foreground">Signed in as</span>
          <span className="truncate font-mono text-xs">{user.email}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <DropdownMenuItem onClick={() => void nav({ to: "/profile" as any })}>
          <UserRound size={14} /> Profile
        </DropdownMenuItem>
        <DropdownMenuItem onClick={toggleTheme}>
          {theme === "dark" ? <Sun size={14} /> : <Moon size={14} />}
          {theme === "dark" ? "Light theme" : "Dark theme"}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="text-fail focus:text-fail">
          <LogOut size={14} /> Log out
        </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
